import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 100);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Backdrop = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const TopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 85px;
  padding: 0 100px 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    top: auto;
    bottom: 15px;
    left: 15px;
    right: 15px;
    padding: 0;
  }
`;

export const ShopInfo = styled.div`
  color: ${({ theme }) => theme.palette.primary.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ShopName = styled.div`
  font-weight: 500;
  font-size: 20px;
`;

export const ShopWorkTime = styled.div`
  color: ${({ theme }) => theme.palette.primary.background};
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
`;

export const HeaderButtons = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 8px;
  }
`;

export const CallButton = styled.button`
  background: ${({ theme }) => theme.palette.system.green};
  color: ${({ theme }) => theme.palette.primary.background};
  border: none;
  width: 220px;
  height: 54px;
  font-size: 15px;
  border-radius: 14px;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background-color: ${({ theme }) => theme.palette.system.deepGreen};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50px;
    height: 50px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0;
    background-image: url('/images/shops/phone-white.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const PhoneNumberButton = styled.a`
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.background};
  border: 2px solid ${({ theme }) => theme.palette.system.green};
  width: 220px;
  height: 54px;
  font-size: 18px;
  border-radius: 14px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: auto;
    min-width: 200px;
    padding: 0 16px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  height: 40px;
  width: 40px;
  top: 20px;
  right: 40px;
  z-index: 10;
  background: none;
  border: none;
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    top: 16px;
    left: 16px;
    right: auto;
    position: fixed;
  }

  &:hover {
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const SlideArea = styled.div`
  position: relative;
  width: 100%;
  max-height: calc(100vh - 140px);
  padding-bottom: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  overflow: hidden;
`;

export const SlideWrapper = styled.div<{
  $activeIndex: number;
  $offsetX: number;
  $isSwiping: boolean;
}>`
  display: flex;
  width: 100%;
  transition: ${({ $isSwiping }) =>
    $isSwiping ? 'none' : 'transform 0.3s ease'};
  transform: ${({ $activeIndex, $offsetX }) =>
    `translateX(calc(-${$activeIndex * 100}% + ${$offsetX}px))`};
`;

export const Arrow = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  width: 60px;
  height: 90px;
  background: transparent;
  border: none;
  z-index: 5;
  cursor: pointer;
  background-image: url('/images/shops/gallery-scroll-button.svg');
  background-repeat: no-repeat;
  background-position: center;
  transform: translateY(-50%)
    ${({ $side }) => ($side === 'left' ? 'rotate(180deg)' : 'rotate(0deg)')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }

  &:hover {
    border-radius: 7px 0 0 7px;
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: calc(100vh - 180px);
  width: 100%;
  margin-top: 80px;

  img {
    max-width: 1280px;
    object-fit: contain;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
      max-width: 100%;
    }
  }
`;

export const VideoWrapper = styled.div`
  width: 900px;
  height: 600px;
  max-width: 100%;
  aspect-ratio: 3 / 2;

  @media (max-width: 949px) {
    width: 100%;
    height: auto;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const SlideCounter = styled.div`
  position: absolute;
  bottom: 80px;
  border-radius: 50px;
  background: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  z-index: 5;
  height: 30px;
  padding: 5px 10px;
  color: ${({ theme }) => theme.palette.primary.background};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    top: 16px;
    bottom: auto;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
`;

export const Thumbnails = styled.div`
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  overflow-x: auto;
  padding: 10px 40px;
  gap: 10px;
  justify-content: flex-start;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const Thumbnail = styled.div<{ $active: boolean }>`
  flex: 0 0 auto;
  cursor: pointer;
  overflow: hidden;
  width: 70px;
  height: 50px;
  transition: border-color 0.3s;
  border-radius: 4px;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.25) 0%,
      rgba(255, 255, 255, 0.25) 100%
    ),
    lightgray 50% / cover no-repeat;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
`;

export const Slide = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100vw;
  }
`;

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  background-color: #d60000;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: 14px solid ${({ theme }) => theme.palette.primary.background};
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    margin-left: 4px;
  }
`;

export const YoutubePreview = styled.div`
  position: relative;
  flex: 0 0 100%;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.primary.background};

  img {
    width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const PhonePopup = styled.div`
  position: absolute;
  top: 60px;
  right: 0;
  left: 0;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 20;
`;

export const PhoneItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  background-image: url('/images/shops/phone.svg');
  background-repeat: no-repeat;
  background-position: 15px center;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 18px;
  font-weight: 500;
  padding: 10px 10px 10px 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ImageGallery = styled.img<{
  $isLarge: boolean;
  $vhOffset?: number;
}>`
  object-fit: contain;
  max-height: ${({ $vhOffset = 180 }) => `calc(100vh - ${$vhOffset}px)`};
  min-width: ${({ $isLarge }) => ($isLarge ? '900px' : '100vw')};
  min-height: ${({ $isLarge }) => ($isLarge ? '600px' : '100vh')};
`;
